import { FocusMetrics } from "@radarly/models/aicha";
import { BaseSearchParams } from "@radarly/models/search";
import { RadarlyAPI } from "./base";

export class AichaAPI extends RadarlyAPI {
  public async getDiscoveryPostlistSummary(
    pid: number,
    request: BaseSearchParams,
    focusMetrics: FocusMetrics[]
  ) {
    return await this.post<{ data: string } | null>(
      `/projects/${pid}/aicha/discovery/postlist-summary`,
      { query: request, metrics: focusMetrics },
      true
    );
  }
  public async getPostlistSummary(
    pid: number,
    request: BaseSearchParams,
    focusMetrics: FocusMetrics[]
  ) {
    return await this.post<{ data: string } | null>(
      `/projects/${pid}/aicha/insight-page/postlist-summary`,
      { query: request, metrics: focusMetrics },
      true
    );
  }
}
